app.service('partnerInsurance', function (price, orderConfig, message, loading, modal) {
	var $self, $insuranceNumber, $euroInsuranceDamageNumber, $otherInsuranceDamageNumber, $insurerPayment, $customerPayment, $insuranceType, $s4message;
	function setEvents() {
		$insuranceType.on('click', function () {
			insuranceType($(this).val());
		});
		$('.js-partner-additional-change', $self).on('click', function () {
			additionalChange($(this).is(':checked'));
		});
		$insurerPayment.on('input', function () {
			insurerPayment();
		}).on('blur', function () {
			blur($insurerPayment, customerPayment);
		});
		$customerPayment.on('input', function () {
			customerPayment();
		}).on('blur', function () {
			blur($customerPayment, insurerPayment);
		});
		$insuranceNumber.on('input', function () {
			checkS4Message();
		})
	}
	function checkS4Message() {
		var value = $insuranceNumber.val().toUpperCase().trim();
		if (value.startsWith('S4')) {
			$s4message.show();
		} else {
			$s4message.hide();
		}
	}
	function blur($input, secondF) {
		const stringValue = '' + $input.val();
		const floatValue = price.number(stringValue);
		const parseValue = price.format(floatValue, false);
		if (parseValue !== stringValue) {
			setInputPrice($input, floatValue);
			secondF();
		}
	}
	function insurerPayment() {
		var total = orderConfig.getData().totalValue;
		var value = price.number($insurerPayment.val());
		var newValue = price.add(total, -value);
		setInputPrice($customerPayment, newValue);
	}
	function customerPayment() {
		var total = orderConfig.getData().totalValue;
		var value = price.number($customerPayment.val());
		var newValue = price.add(total, -value);
		setInputPrice($insurerPayment, newValue);
	}
	function setInputPrice($input, value) {
		if (value >= 0) {
			$input.val(price.format(value, false));
		} else {
			$input.val('');
		}
	}
	function additionalChange(checked) {
		if (checked) {
			$self.addClass('has-additional-change');
		} else {
			$self.removeClass('has-additional-change');
		}
	}
	function insuranceType(type) {
		$self.removeClass('euro other');
		if (type == 'EURO') {
			$self.addClass('euro');
			$insuranceNumber.prop('disabled', false);
			$euroInsuranceDamageNumber.prop('disabled', false);
			$otherInsuranceDamageNumber.prop('disabled', true);
			if ($otherInsuranceDamageNumber.val() != '') {
				$euroInsuranceDamageNumber.val($otherInsuranceDamageNumber.val());
			}
			$otherInsuranceDamageNumber.val('');
		} else {
			$self.addClass('other');
			$insuranceNumber.prop('disabled', true);
			$euroInsuranceDamageNumber.prop('disabled', true);
			$otherInsuranceDamageNumber.prop('disabled', false);
			if ($euroInsuranceDamageNumber.val() != '') {
				$otherInsuranceDamageNumber.val($euroInsuranceDamageNumber.val());
			}
			$euroInsuranceDamageNumber.val('');
		}
	}
	function init() {
		$self = $('#partner-insurance-box');
		if ($self.length) {
			$insuranceType = $('.js-partner-insurance-type', $self);
			$insuranceNumber = $('#partner-euro-insurance input[name=insuranceNumber]', $self);
			$s4message = $('#s4-message', $self);
			$euroInsuranceDamageNumber = $('#partner-euro-insurance input[name=insuranceDamageNumber]', $self);
			$otherInsuranceDamageNumber = $('#partner-other-insurance input[name=insuranceDamageNumber]', $self);
			$insurerPayment = $('input[name=insurerPayment]', $self);
			$customerPayment = $('input[name=customerPayment]', $self);
			setEvents();
		}
	}
	function checkNext(callback) {
		if ($insuranceType.filter(':checked').val() == 'OTHER') {
			message.get('Tryb partnera - weryfikacja udziału własnego').then(function (result) {
				loading.stop();
				modal.generate({
					id: 'partner-check-modal',
					content: '<p>' + result + '</p>',
					buttons: [{
						text: 'Anuluj',
						cssClass: 'button-cancel',
						click: function () {
							modal.close();
						}
					}, {
						text: 'Dalej',
						cssClass: 'button-next',
						click: function () {
							modal.close();
							callback();
						}
					}]
				});
			});
			return false;
		} else {
			return true;
		}
	}
	return {
		init,
		checkNext
	};
});
